import type { BackgroundJobScheduleDto } from "@/api/dtos";
import type { BackgroundJobSchedule, BackgroundJobScheduleFrequency } from "@/api/background-job/_models/BackgroundJobSchedule";
import { toBackgroundJobFromBackgroundJobDto } from "./toBackgroundJobFromBackgroundJobDto";

export const toBackgroundJobScheduleFromBackgroundJobScheduleDto = (dto: BackgroundJobScheduleDto): BackgroundJobSchedule => {
  let lastJob = undefined;
  if (dto.lastJob) lastJob = toBackgroundJobFromBackgroundJobDto(dto.lastJob);
  return {
    id: dto.id,
    name: dto.name,
    kind: dto.kind,
    frequency: dto.frequency as BackgroundJobScheduleFrequency,
    intervalMinutes: dto.intervalMinutes,
    minute: dto.minute,
    time: dto.time,
    weekdays: dto.weekdays,
    enabled: dto.enabled,
    nextRunAt: dto.nextRunAt ?? undefined,
    lastJob,
  };
};
